jQuery(document).ready(function( $ ){

	var scroll_duration = 1000;
	var navbar_height = 60;

	// to div by id
	$('a.scroll-to').click(function( event ) {
			event.preventDefault();
			var target = $(this.hash);
			var topoffset = target.offset().top - navbar_height;
				$('html,body').animate({
					scrollTop: topoffset
				}, scroll_duration);
				return false;
	});
	// for 100%
	$('.scroll-100').click(function( event ) {
			event.preventDefault();
			var topoffset = (window.innerHeight + 1);
				$('html,body').animate({
					scrollTop: topoffset
				}, scroll_duration);
				return false;
	});
  // To top
	$('.scroll-top').click(function( event ) {
				event.preventDefault();
					$('html,body').stop().animate({
						scrollTop: 0
					}, scroll_duration);
					return false;
	});

	// END JQUERY
});
